export default "__VITE_ASSET__8160cc1f__"